
export interface LockBackend {

    /**
     * Open a shared lock
     */
    shared<T>(name: string, cb: () => Promise<T>, signal?: AbortSignal): Promise<T>;

    /**
     * Open an exclusive lock.
     */
    exclusive<T>(name: string, cb: () => Promise<T>, signal?: AbortSignal): Promise<T>;

}


class WebLockBackend implements LockBackend {
    private manager: LockManager;

    constructor(manager: LockManager) {
        this.manager = manager;
    }

    async shared<T>(name: string, cb: () => Promise<T>, signal?: AbortSignal): Promise<T> {
        return await this.manager.request(name, {mode: "shared", signal}, cb);
    }

    async exclusive<T>(name: string, cb: () => Promise<T>, signal?: AbortSignal): Promise<T> {
        return await this.manager.request(name, {mode: "exclusive", signal}, cb);
    }
}


interface LockConstructor<T extends LockBackend> {
    new(...params: any[]): T;
}


class ImportBackend<T extends LockBackend> implements LockBackend {
    private _backend: Promise<LockBackend>|null = null;
    private builder: () => Promise<LockBackend>;


    constructor(build: () => Promise<{default: LockConstructor<T>}>, ...params: any[]) {
        this.builder = async () => new (await build()).default(...params);
    }

    private get backend(): Promise<LockBackend> {
        if (!this._backend) {
            this._backend = this.builder();
        }
        return this._backend!;
    }

    async shared<T>(name: string, cb: () => Promise<T>, signal?: AbortSignal): Promise<T> {
        return await (await this.backend).shared(name, cb, signal);
    }

    async exclusive<T>(name: string, cb: () => Promise<T>, signal?: AbortSignal): Promise<T> {
        return await (await this.backend).exclusive(name, cb, signal);
    }
}


// SAFARI: Doesn't implement the WebLockAPI-Standard despite being
//         part of baseline since 2022.
export const LockBackend = 
    !!window.navigator["locks"]
    ? new WebLockBackend(window.navigator.locks)
    : new ImportBackend(() => import("../polyfills/locks"));

if (process.env.NODE_ENV === 'development') {
    (window as any)["LockBackend"] = LockBackend;
}
